import React from 'react';
import Loading from './Loading';
import Table from './Table';

const FailedLogins = ({entries}) => {
  if (entries === null) return <Loading />;

  return (
    <div style={{width: 'calc(100% - 40px)',
                 overflowY: 'auto',
                 padding: '20px',
                 display: 'flex',
                 flexDirection: 'column',
                 gap: '20px',
                }}>

      <Table headers={['IP', 'Date', 'Time', 'Timezone', 'Email', 'Type']}
             contents={entries.map(({ ip, date, time, timezone, email, type }) => {
               return [ip, date, time, timezone, email, type];
             })}
             proportions={[1, 1, 1, 1, 2, 1]} />
    </div>
  );
}

export default FailedLogins;
